// ABOUTME: The 5C layer: a parchment card naming the storm and holding its guiding truth, with no star, placed in the upper sky.
// ABOUTME: The truth is real text with its line breaks kept; the card is not an image.

import { Box, Typography } from '@mui/material';
import { CROSSING_GOLD_INK, CROSSING_HEADLINE_INK, CROSSING_TRUTH_CARD_BORDER, CROSSING_TRUTH_CARD_GROUND } from '../../../../theme/crossingTokens';

interface GuidingTruthCardProps {
  stormName: string;
  truth: string;
}

export default function GuidingTruthCard({ stormName, truth }: GuidingTruthCardProps) {
  return (
    <Box
      data-testid="guiding-truth-card"
      sx={{
        position: 'absolute', left: '50%', top: 'calc(12% + 34px)', transform: 'translateX(-50%)',
        width: { xs: 262, sm: 360 }, maxWidth: 'calc(100% - 32px)', boxSizing: 'border-box', py: '9px', px: '16px',
        backgroundColor: CROSSING_TRUTH_CARD_GROUND, border: `1px solid ${CROSSING_TRUTH_CARD_BORDER}`, borderRadius: '14px', textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '11px', fontWeight: 800, letterSpacing: '1.8px', color: CROSSING_GOLD_INK }}>
        {stormName} · GUIDING TRUTH ★
      </Typography>
      <Typography sx={{ mt: 0.75, fontFamily: 'Newsreader, serif', fontWeight: 600, fontSize: '17px', color: CROSSING_HEADLINE_INK, whiteSpace: 'pre-line' }}>
        “{truth}”
      </Typography>
    </Box>
  );
}
